import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');

// Use hydrateRoot if the page was pre-rendered by react-snap
// Otherwise use createRoot for client-side rendering
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ));
} else {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

